import { useEffect, useRef, useState } from 'react'
import { CommonTransition } from '../utils/CommonTransition'
import { useIsInViewport } from '../utils/CustomHooks'
import { ASSETS_URL } from '../utils/constants'

const whyGoSolar1 = ASSETS_URL + 'whyGoSolar-1.png'
const whyGoSolar2 = ASSETS_URL + 'whyGoSolar-2.jpg'

export const WhyGoSolar = () => {
    const containerRef = useRef(null)
    const isInViewport = useIsInViewport(containerRef)
    const [animateOnce, setAnimateOnce] = useState(false)
    useEffect(() => {
        if(isInViewport) {
            setAnimateOnce(true)
        }
    }, [isInViewport])
    return <div ref={containerRef}>
        <CommonTransition open={animateOnce} durationEnter={'duration-[1000ms]'} enterFrom={'translate-y-full'}>
            <div className='font-[Montserrat] text-[#4CB117] text-center text-3xl sm:text-5xl font-extrabold pb-3  mt-8'>Why Go Solar?</div>
        </CommonTransition>
        <div className='font-[Montserrat] w-full flex flex-col sm:flex-row text-left text-[#f7f7f7] justify-center my-10 sm:my-20'> 
            <div className='order-2 sm:order-1 w-full sm:w-[35%] px-8 mt-10 sm:mt-0'>
                <div>
                    <CommonTransition open={animateOnce} durationEnter={'duration-[2000ms]'} enterFrom={'-translate-x-10'}>
                        <div className='text-xl sm:text-4xl'>REDUCE BILL</div>
                    </CommonTransition>
                    <CommonTransition open={animateOnce} durationEnter={'duration-[3000ms]'}>
                        <div>
                            <div className='text-md sm:text-xl'>Solar Panels help to reduce or to eliminate electricity bill</div>
                            <hr className='my-6'/>
                        </div>
                    </CommonTransition>
                </div>
                
                <div>
                    <CommonTransition open={animateOnce} durationEnter={'duration-[2000ms]'} enterFrom={'-translate-x-10'}>
                        <div className='text-xl sm:text-4xl'>CLEAN & RENEWABLE ENERGY</div>
                    </CommonTransition>
                    <CommonTransition open={animateOnce} durationEnter={'duration-[3000ms]'}>
                        <div className='text-md sm:text-xl'>
                            <div className='pb-2'>Generate CLEAN energy from a renewable source</div>
                            <div>Every 1kWh of solar energy reduces CO2 by 0.534 kilograms</div>
                            <hr className='my-6'/>
                        </div>
                    </CommonTransition>
                    
                </div>
                
                <div>
                    <CommonTransition open={animateOnce} durationEnter={'duration-[2000ms]'} enterFrom={'-translate-x-10'}>
                        <div className='text-xl sm:text-4xl'>INCREASE PROPERTY VALUE</div>
                    </CommonTransition>
                    <CommonTransition open={animateOnce} durationEnter={'duration-[3000ms]'}>
                        <div className='text-md sm:text-xl'>
                            <div>Enhance your property value and monetize your roof</div>
                            <hr className='sm:hidden my-6'/>
                        </div>
                    </CommonTransition>
                </div>
            </div>
            <div className='order-1 sm:order-2 flex shrink-0 justify-center'>
                <CommonTransition open={animateOnce} durationEnter={'duration-[2000ms]'} enterFrom={'translate-y-full'}>
                    <img alt="'total solar installation','total solar installation by rb gonzales opc','total solar', 'total solar ph', 'total solar philippines', 'solar panel installer', 'solar panel provider', 'solar panel philippines'" src={whyGoSolar2} className={'object-cover w-[100px] h-[200px] sm:w-[150px] sm:h-[300px] skew-x-0 skew-y-[-30deg] -mr-10'}/>
                </CommonTransition>
                <CommonTransition open={animateOnce} durationEnter={'duration-[2800ms]'} enterFrom={'translate-y-full'}>
                    <img alt="'total solar installation','total solar installation by rb gonzales opc','total solar', 'total solar ph', 'total solar philippines', 'solar panel installer', 'solar panel provider', 'solar panel philippines'" src={whyGoSolar1} className={'object-cover w-[100px] h-[200px] sm:w-[150px] sm:h-[300px] skew-x-0 skew-y-[-30deg] -ml-10 mt-10'}/>
                </CommonTransition>
                
            </div>
            <div className='order-3 w-full sm:w-[35%] px-8'>
                <div>
                    <CommonTransition open={animateOnce} durationEnter={'duration-[2000ms]'} enterFrom={'translate-x-10'}>
                        <div className='text-xl sm:text-4xl'>SUSTAINABILITY & INNOVATION</div>
                    </CommonTransition>
                    <CommonTransition open={animateOnce} durationEnter={'duration-[3000ms]'}>
                        <div className='text-md sm:text-xl'>
                            <div className='pb-2'>Demonstrate a corporate image of sustainability and social responsibility</div>
                            <div>Be an Innovation Leader and an example in your industry for the use of new technology</div>
                            <hr className='my-6'/>
                        </div>
                    </CommonTransition>
                </div>
                
                <div>
                    <CommonTransition open={animateOnce} durationEnter={'duration-[2000ms]'} enterFrom={'translate-x-10'}>
                        <div className='text-xl sm:text-4xl'>HELPS REDUCE HVAC REQUIREMENTS</div>
                    </CommonTransition>
                    <CommonTransition open={animateOnce} durationEnter={'duration-[3000ms]'}>
                        <div className='text-md sm:text-xl'>
                            <div className='pb-2'>Reduced (Heating, Ventilation, and Air Conditioning) HVAC requirements</div>
                            <div>Solar panels provide added insulation from the heat of solar radiation</div>
                        </div>
                    </CommonTransition>
                </div>
            </div>
        </div>
    </div>
}